import Vue from 'vue'

import axios from 'axios'

import i18n from './i18n'

import store from './store.es6'

import moment from 'moment-timezone'

import Observer from './observer/main-window.vue'

import './assets/app-styles.sass'

import { library as fa } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

import 'leaflet-editable'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import expressUseragent from 'express-useragent'

import JWT from 'jsonwebtoken'

import VueCookies from 'vue-cookies'
import AsyncComputed from 'vue-async-computed'

import vuetify from './vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyToast from 'vuetify-toast-snackbar'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

import VueRouter from 'vue-router'
import Router from './router'
import VueTour from 'vue-tour'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import 'vue-search-select/dist/VueSearchSelect.css'

import './registerServiceWorker'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { initUserInSession } from './observer/_initiators/login.es6'

Vue.prototype.$http = axios

// QFIX: Timezone everywhere set to Prague
moment.locale(window.localStorage.getItem('userLanguage') || 'en')

Vue.use(AsyncComputed)

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyCeYX8QuqoI0WBDrEkvVJfElVGs-REGirU',
    key: 'AIzaSyCAxLKWXDa0GzQ75Ru233bASrAj5lRK_ro',
    libraries: 'places' // If you need to use place input
  }
})

Vue.component('GmapCluster', GmapCluster)
Vue.component('GmapCustomMarker', GmapCustomMarker)

const hostname = () => {
  let hostname = ''
  if (process.env.NODE_ENV === 'production') {
    hostname = `${window.location.hostname}`
  } else {
    hostname = `${window.location.hostname}:8080`
  }
  return hostname
}
Vue.prototype.$hostname = hostname()

// Mobile or Desktop
const userAgentAll = new expressUseragent.UserAgent().parse(navigator.userAgent)
store.commit('setUserAgent', {
  isDesktop: userAgentAll.isDesktop,
  isMobile: userAgentAll.isMobile
})

// User rights management
Vue.prototype.$can = function (grant) {
  // userRoles: admin, manager, worker, ...

  // 1. Testing for user role
  let userRole = ''
  let token = this.$cookies.get('session')
  if (this.$cookies.isKey('session')) {
    userRole = JWT.decode(token).role
  }

  if (userRole === 'admin') {
    return ['worker', 'dispatcher', 'manager', 'admin'].includes(grant)
  } else if (userRole === 'manager') {
    return ['worker', 'dispatcher', 'manager'].includes(grant)
  } else if (userRole === 'dispatcher') {
    return ['worker', 'dispatcher'].includes(grant)
  } else if (userRole === 'worker') {
    return ['worker'].includes(grant)
  }
  return false
}

Vue.prototype.$cans = function (siteName) {
  // siteName: bru, prg, ...
  if (siteName === store.state.site.name) {
    return true
  }
  return false
}

Vue.prototype.$canm = function (module, feature = null) {
  // module: vis, mnt, complexName ...
  if (store.state.site.modules.enabled.includes(module)) {
    return feature ? store.state.site.modules[module][feature] : true
  }
  return false
}

Vue.prototype.$devel = function () {
  return store.state.developerMode
}

const baseUrl = process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : (process.env.NODE_ENV === 'production' ? `https://${hostname()}/api` : `http://${hostname()}/api`)
axios.defaults.baseURL = baseUrl
axios.defaults.headers.common['Accept'] = 'application/json'

// Filters

Vue.filter('date', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY').replace(/ /g, '\u00a0')
  }
})

Vue.filter('datetime', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm').replace(/ /g, '\u00a0')
  }
})

// VueCookies
Vue.use(VueCookies)

// Vuetify
// initialized in ./vuetify.js file

// Vuetify toast service
Vue.use(VuetifyToast, {
  x: 'center'
})

// Vuetify dialog service
//Vue.use(VuetifyDialog, { context: { vuetify } })
Vue.use(VuetifyDialog, { context: { vuetify, i18n, store } })

// Vue Router
Vue.use(VueRouter)

// Font Awesome
fa.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)


// Vue tour - onboarding
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// @riophae/vue-treeselect
Vue.component('treeselect', Treeselect)

if (window.location.protocol === 'file:' || window.location.port === '8000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

initVue()

async function initVue () {
  store.commit('setMapOptions', { apikey: 'AIzaSyCAxLKWXDa0GzQ75Ru233bASrAj5lRK_ro' })
  await store.dispatch('getSiteConfig')
  moment.tz.setDefault(store.state.site.timezone)
  // Initiate the Vue instance
  if (document.getElementById('observer')) {
    /* eslint-disable no-new */
    let app = new Vue({
      el: '#observer',
      store,
      i18n,
      router: Router,
      vuetify: vuetify,
      async created () {
        // Init user from token in cookies on refresh
        await initUserInSession(this)
          .catch(error => console.error(error))

        // Save hostname to store (for websockets re-connecting)
        this.$store.commit('setFlat', { param: 'hostname', val: hostname() })
      },
      render (h) {
        return h(Observer, {
          props: {}
        })
      }
    })

    if (window.Cypress) {
      // only available during E2E tests
      window.app = app
    }
  }
}
